import Sentry from "./common/utils/middleware/config.sentry.js";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { ClarityProvider } from "@artprov/design-system";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ClarityProvider projectId={import.meta.env.VITE_CLARITY_ID} sentry={Sentry}>
    <App />
  </ClarityProvider>,
);
